import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { LoginService } from './login.service';
import { User } from '../../classes/User';
import { Client } from '../../classes/Client';
import { Product } from '../../classes/Product';
import { Project } from '../../classes/Project';
import { Light } from '../../classes/Light';
import { Zone } from '../../classes/Zone';
import { Manufacturer } from '../../classes/Manufacturer';
import { Rebate } from '../../classes/Rebate';
import { Supplier } from '../../classes/Supplier';

import { PDFGenerator } from './html_pdf/pdf-html';

@Injectable( )
export class ModelService {

  constructor ( 
      private global: GlobalService,
      private loginService: LoginService ) { }


  PDFHandler = new PDFGenerator( );



  checkToken ( response ) {
    let data;
    try {
      data = response.json( );
      if ( data.error === 'token_expired' ) {
        this.loginService.logout( );
        return false;
      } else return true;
    } catch ( exception ) {
      return false;
    }
  }

  makeBackendCall( sendData, requestUrl, cb ) {

    this.global.postRequestToken( 'request/' + requestUrl, sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    }, false, false, true);
  }

  exportProductCSV ( cb ) {

    this.makeBackendCall({}, 'extractProductsCSV', cb );
  }

  uploadLinkSpec( formdata, cb ) {

    this.makeBackendCall( formdata, 'uploadLinkSpec', cb );
  }

  linkImageToProducts( image_link, ids, cb ) {

    let data = {
      image_link: image_link,
      ids: ids
    };
    this.makeBackendCall( data, 'linkImageToProducts', cb );
  }

  saveViaQuickbooks( id, viaQuickbooks, cb ) {
    let senddata = {
      id: id,
      viaQuickbooks: viaQuickbooks
    };
    this.makeBackendCall( senddata, 'saveViaQuickbooks', cb );
  }

  exportSingleCSV( id, cb ) {

    let senddata = {
      id: id
    };
    this.makeBackendCall( senddata, 'extractSingleInvoiceCSV', cb );
  }

  //Old style methods
  //ToDo rewrite them all

  /*==============================================================================*\
  
                                CLIENTS API

  \*==============================================================================*/

  getClientsData ( cb, sortingField?, show_all? ) {

    let sendData = { };
    let _clients = [];
    if ( sortingField ) sendData['orderBy'] = sortingField;
    if ( show_all ) sendData['show_all'] = show_all;
    this.global.postRequestToken( 'request/clients', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).clients ) _clients = response.json( ).clients;
      if ( this.global.isFunction( cb ) ) cb( _clients );
    });        
  }

  getClientDataByID ( id, cb ) {

    let _client: Client = new Client( );

    let sendData = { id: id };
    this.global.postRequestToken( 'request/client', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).client ) _client = response.json( ).client;
      if ( this.global.isFunction( cb ) ) cb( _client );
    });        
  }

  addClient ( clientData, cb ) {

    let sendData = { client: clientData };
    this.global.postRequestToken( 'request/addClient', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }

  editClient ( clientData, cb ) {

    let sendData = { client: clientData };
    this.global.postRequestToken( 'request/editClient', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }


  // ToDo separate to a file near projects folder
  /*==============================================================================*\
  
                                PROJECTS API

  \*==============================================================================*/

  getProjectsData ( cb, show_all?, paginationData? ) {

    let _pagination = {
      count: 100,
      offset: 0,
      count_all: 0,
      currentPage: 1,
      maxPage: 1
    };
    let _projects = { };
    let sendData = { };
    if ( show_all ) sendData['show_all'] = show_all;
    if ( paginationData ) sendData['pagination'] = paginationData;

    this.global.postRequestToken( 'request/projects', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).projects ) _projects = response.json( ).projects;
      if ( response.json( ).pagination ) _pagination = response.json( ).pagination;
      if ( this.global.isFunction( cb ) ) cb( _projects, _pagination );
    });        
  }

  getProjectsDataTable ( cb, show_all?, requestData?, withoutPreloader? ) {

    let _withoutPreloader = true;
    if ( withoutPreloader === false ) _withoutPreloader = false;
    let _pagination = {
      count: 100,
      offset: 0,
      count_all: 0,
      currentPage: 1,
      maxPage: 1
    };

    let _reqData = this.global.cloneObject( requestData );
    let _projects, _sorting, _filters, _commission = '0.00', _sales = '0.00';

    if ( !_reqData['pagination'] ) _reqData['pagination'] = _pagination;

    this.global.postRequestToken( 'request/projectsTable', _reqData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).data ) _projects = response.json( ).data;
      if ( response.json( ).pagination ) _pagination = response.json( ).pagination;
      if ( response.json( ).sorting ) _sorting = response.json( ).sorting;
      if ( response.json( ).filters ) _filters = response.json( ).filters;
      if ( response.json( ).all_comission ) _commission = response.json( ).all_comission;
      if ( response.json( ).AllProductCost ) _sales = response.json( ).AllProductCost;
      if ( this.global.isFunction( cb ) ) cb( _projects, _pagination, _sorting, _filters, _commission, _sales );
    }, _withoutPreloader);        
  }

  getTaxesData ( cb ) {

    this.global.postRequestToken( 'request/taxes', { }, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ).taxes );
    }); 
  }

  addTax ( taxData ) {

    return new Promise( ( resolve, reject ) => {
      try {
        this.global.postRequestToken( 'request/addTax', taxData, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          resolve( response.json( ) );
        }); 
      } catch ( error ) {
        reject( new Error ( error ) );
      }
    });

  }

  editTax ( taxData ) {

    return new Promise( ( resolve, reject ) => {
      try {
        this.global.postRequestToken( 'request/editTax', taxData, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          resolve( response.json( ) );
        }); 
      } catch ( error ) {
        reject( new Error ( error ) );
      }
    });

  }

  getProjectCurrentTax ( projectID ) {

    return new Promise( ( resolve, reject ) => {
      try {
        this.global.postRequestToken( 'request/tax', { id: projectID }, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          resolve( response.json( ) );
        }); 
      } catch ( error ) {
        reject( new Error ( error ) );
      }
    });

  }

  deleteTax ( id ) {

    let sendData = { id: id };

    return new Promise( ( resolve, reject ) => {
      try {
        this.global.postRequestToken( 'request/deleteTax', sendData, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          resolve( response.json( ) );
        }); 
      } catch ( error ) {
        reject( new Error ( error ) );
      }
    });

  }


  getSKUList ( SKUSearch ) {

    return new Promise( ( resolve, reject ) => {
      try {
        this.global.postRequestToken( 'request/GetSKUList ', { search: SKUSearch }, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          resolve( response.json( ) );
        }); 
      } catch ( error ) {
        reject( new Error ( error ) );
      }
    });

  }

  getDescriptionList ( descriptionSearch ) {

    return new Promise( ( resolve, reject ) => {
      try {
        this.global.postRequestToken( 'request/GetDescriptionList ', { search: descriptionSearch }, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          resolve( response.json( ) );
        }); 
      } catch ( error ) {
        reject( new Error ( error ) );
      }
    });

  }

  getProjectsListData ( cb ) {

    let sendData = { };
    this.global.postRequestToken( 'request/projectsList', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });        
  }

  getProjectDataByID ( id, cb ) {

    let project: Project = new Project( );
    let permission: string = '';
    let parsedResponse;

    let sendData = { id: id };
    this.global.postRequestToken( 'request/project', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      parsedResponse = response.json();
      if ( parsedResponse.project ) {
        project = parsedResponse.project;
      }
      if ( parsedResponse.permission ) {
        permission = parsedResponse.permission;
      }
      if ( this.global.isFunction( cb ) ) cb( project, permission );
    });        
  }

  getAdminDashboardData ( requestData, cb, withoutPreloader? ) {

    let _reqData = this.global.cloneObject( requestData );
    let _withoutPreloader = true;
    if ( withoutPreloader === false ) _withoutPreloader = false;

    for ( let item in _reqData['filters'] ) {
      if ( item !== 'fromDate' && item !== 'toDate' ) _reqData['filters'][item] = encodeURIComponent( _reqData['filters'][item] );
    }

    this.global.postRequestToken( 'request/adminDashboardData', _reqData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    }, _withoutPreloader );        
  }

  exportCSV ( cb ) {

    let sendData = {};
    this.global.postRequestToken( 'request/extractInvoiceCSV', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  extractPurchaseCSV ( cb ) {

    let sendData = { 
      // date_from: _from,
      // date_to: _to
    };
    this.global.postRequestToken( 'request/extractPurchaseCSV', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  addProject ( projectData, cb ) {

    let sendData = { project: projectData };
    this.global.postRequestToken( 'request/addProject', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }

  editProject ( projectData, cb ) {

    let sendData = { project: projectData };
    this.global.postRequestToken( 'request/editProject', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }

  deleteProjectAttachment ( id, cb ) {

    let sendData = { id: id };
    this.global.postRequestToken( 'request/deleteProjectAttachment', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }


  getProjectProfit ( id, cb ) {

    let _profit = 0;

    let sendData = { id: id };
    this.global.postRequestToken( 'request/getProjectProfit', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).profit ) _profit = response.json( ).profit;
      if ( this.global.isFunction( cb ) ) cb( _profit );
    });

  };


  getProjectPurchaseInfoData ( manufacturer_id, project_id, cb ) {

    let sendData = { 
      manufacturer: manufacturer_id, 
      project: project_id 
    };
    this.global.postRequestToken( 'request/projectPurchaseInfo', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });

  };

  saveRates ( project_id, manufacturer_id, rates, cb ) {

    let sendData = { 
      projectID: project_id,
      manufacturerID: manufacturer_id, 
      rates: rates
    };
    this.global.postRequestToken( 'request/saveRate', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });

  };
    
  saveLightPrices ( project_id, products, cb ) {

    let sendData = { 
      projectID: project_id,
      rates: products
    };
    this.global.postRequestToken( 'request/saveLightPrices', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });

  };
    

  generateManufacturerPurchasePDF ( sendData, cb ) {

    let _resp;
    this.global.showPreloader( );
    this.global.postRequestToken( 'request/addPurchaseOrder', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      _resp = response.json( );
      sendData.orderNumber = _resp.orderNumber;
      this.global.showPreloader( );
      this._genManPurPDF ( sendData, cb );
    }, true);
  }

  _genManPurPDF ( sendData, cb ) {

    let _for_html = '';
    let _url = '';
    
    this.PDFHandler.generateManufacturerPurchasePDF( sendData );

    let _sendData = {
      html: this.PDFHandler.styles+this.PDFHandler.content,
      project_id: sendData.project_id,
      manufacturer_id: sendData.manufacturer_id,
      manufacturer_name: sendData.manufacturer,
      purchase_order_number: sendData.orderNumber,
      date: sendData.orderDate
    };

    this.global.postRequestToken( 'request/purchaseManufacturerPDF', _sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
      this.global.hidePreloader( );
    }, true);
  }

  sendManufacturerEmail ( sendData, cb ) {

    this.global.postRequestToken( 'request/sendMails', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  sendDataEmail ( sendData, cb ) {

    this.global.postRequestToken( 'request/sendInvoiceMail', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  /*==============================================================================*\
  
                                USERS API

  \*==============================================================================*/  



  getUsersData ( cb, filters? ) {

    let sendData = { filters: {} };
    if ( filters ) sendData['filters'] = filters;
    this.global.postRequestToken( 'request/users', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });        
  }

  getUserDataByID ( id, cb ) {

    let _user: User = new User( );

    let sendData = { id: id };
    this.global.postRequestToken( 'request/user', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).user ) _user = response.json( ).user;
      if ( this.global.isFunction( cb ) ) cb( _user );
    });        
  }

  addUser ( userData, cb ) {

    let sendData = { user: userData };
    this.global.postRequestToken( 'request/addUser', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  editUser ( userData, cb ) {

    let sendData = { user: userData };
    this.global.postRequestToken( 'request/editUser', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  changePassword ( newPassword, cb ) {

    let sendData = { password: newPassword };
    this.global.postRequestToken( 'request/changePassword', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  getCustomAdmins ( cb ) {

    let customAdmins: any[] = [];

    this.global.postRequestToken( 'request/getCustomAdmins', {}, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      customAdmins = response.json( ).users;
      if ( this.global.isFunction( cb ) ) cb( customAdmins );
    }); 

  }

  /*==============================================================================*\
  
                                PRODUCTS API

  \*==============================================================================*/  

  getProductsData ( cb, filters, show_all?, paginationData?, withoutPreloader? ) {

    let _withoutPreloader = false;
    if ( withoutPreloader ) _withoutPreloader = true;
    let _products = [];
    let _dropdowns = {};
    let _response: any = {};
    let create_existing: boolean = false;
    let _pagination = {
      count: 100,
      offset: 0,
      count_all: 0,
      currentPage: 1,
      maxPage: 1
    };
    let sendData = { filters_in_list: filters };
    if ( show_all ) sendData['show_all'] = show_all;
    if ( paginationData ) sendData['pagination'] = paginationData;
    this.global.postRequestToken( 'request/products', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      _response = response.json( );
      if ( _response.products ) _products = _response.products;
      if ( _response.pagination ) _pagination = _response.pagination;
      if ( _response.dropdowns ) _dropdowns = _response.dropdowns;
      if ( _response.create_existing ) create_existing = _response.create_existing;
      if ( this.global.isFunction( cb ) ) cb( _products, _pagination, _dropdowns, create_existing );
    }, _withoutPreloader );        
  }

  getProductsDataExcluding ( filters, changed, cb, from?, withoutPreloader?, selectedOption? ) {

    let _withoutPreloader = false;
    if ( withoutPreloader ) _withoutPreloader = true;
    let _products = [];
    let _filters = {
      manufacturer: [],
      productType: [],
      baseType: [],
      description: []
    };

    filters.selectedOption = selectedOption ? selectedOption : 'A';

    let _from = 'projectZones';

    if ( from ) _from = from;

    let sendData = { filters: filters, changed: changed, from: from };
    this.global.postRequestToken( 'request/products', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).products ) _products = response.json( ).products;
      if ( response.json( ).filters ) _filters = response.json( ).filters;
      if ( this.global.isFunction( cb ) ) cb( _products, _filters );
    }, _withoutPreloader );        
  }

  getProductDataByID ( id, cb, _sendData? ) {

    let _product: Product = new Product( );
    let sendData = { id: id };
    if ( _sendData ) sendData = _sendData;
    sendData['id'] = id;
    this.global.postRequestToken( 'request/product', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).product ) _product = response.json( ).product;
      if ( this.global.isFunction( cb ) ) cb( _product );
    });        
  }

  addProduct ( ProductData, cb ) {
  
    let sendData = { product: ProductData };
    this.global.postRequestToken( 'request/addProduct', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  editProduct ( ProductData, cb ) {

    let sendData = { product: ProductData };
    this.global.postRequestToken( 'request/editProduct', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  cloneProduct ( SKUs, productID, cb ) {

    let sendData = { 
      SKUs: SKUs,
      id: productID 
    };
    this.global.postRequestToken( 'request/cloneProduct', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  makeProductsInactive ( ids, cb ) {

    let sendData = { ids: ids };
    this.global.postRequestToken( 'request/makeProductsInactive', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  deleteProductAttachment ( id, cb ) {
    let sendData = { id: id };
    this.global.postRequestToken( 'request/deleteProductAttachment', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }


  getProductsTypeData ( manufacturer, entity, cb ) {

    let _productData = [];
    let sendData = { 
      manufacturer: manufacturer,
      entity: entity
    };

    this.global.postRequestToken( 'request/getProductTypesByManufacturer', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).productTypes ) _productData = response.json( ).productTypes;
      if ( this.global.isFunction( cb ) ) cb( _productData );
    });        
  }


  getBaseTypeData ( manufacturer, productType, entity, cb ) {

    let _baseData = [];
    let sendData = { 
      productType: productType,
      manufacturer: manufacturer,
      entity: entity
    };

    this.global.postRequestToken( 'request/getBaseTypesByManufacturer', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).baseTypes ) _baseData = response.json( ).baseTypes;
      if ( this.global.isFunction( cb ) ) cb( _baseData );
    });        
  }


  getProductsSpecsData ( requestData, cb, withoutPreloader? ) {

    let _data: any = {}

    let _reqData = this.global.cloneObject( requestData );
    let _withoutPreloader = true;
    if ( withoutPreloader === false ) _withoutPreloader = false;

    for ( let item in _reqData['filters'] ) {
      _reqData['filters'][item] = encodeURIComponent( _reqData['filters'][item] );
    }

    this.global.postRequestToken( 'request/specsList', _reqData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ) ) _data = response.json( );
      if ( this.global.isFunction( cb ) ) cb( _data );
    }); 
  }

  createExistingProductsForProposed ( cb ) {
    this.global.postRequestToken( 'request/createExistingForProposed', {}, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });  
  }

  /*==============================================================================*\
  
                                MANUFACTURERS API

  \*==============================================================================*/  

  getManufacturersData ( cb, show_all? ) {

    let _manufacturers = [];
    let sendData = { };
    if ( show_all ) sendData['show_all'] = show_all;
    this.global.postRequestToken( 'request/manufacturers', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).manufacturers ) _manufacturers = response.json( ).manufacturers;
      if ( this.global.isFunction( cb ) ) cb( _manufacturers );
    });        
  }

  getManufacturersDataWithEntity ( entity, cb ) {

    let _manufacturers = [];
    let sendData = { entity: entity };
    this.global.postRequestToken( 'request/manufacturers', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).manufacturers ) _manufacturers = response.json( ).manufacturers;
      if ( this.global.isFunction( cb ) ) cb( _manufacturers );
    });        
  }

  getManufacturerDataByID ( id, cb ) {
    let _manufacturer: Manufacturer = new Manufacturer( );
    let sendData = { id: id };
    this.global.postRequestToken( 'request/manufacturer', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).manufacturer ) _manufacturer = response.json( ).manufacturer;
      if ( this.global.isFunction( cb ) ) cb( _manufacturer );
    });        
  }

  addManufacturer ( ManufacturerData, cb ) {

    let sendData = { manufacturer: ManufacturerData };
    this.global.postRequestToken( 'request/addManufacturer', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  editManufacturer ( ManufacturerData, cb ) {

    let sendData = { manufacturer: ManufacturerData };
      this.global.postRequestToken( 'request/editManufacturer', sendData, this.loginService.userInfo.token, ( response ) => {
        if ( !this.checkToken( response ) ) return;
        if ( this.global.isFunction( cb ) ) cb( response );
      });
  }



  /*==============================================================================*\
  
                                REBATES API

  \*==============================================================================*/  

  getRebatesData ( cb, _sendData? ) {

    let _rebates = [];
    let sendData = { };
    if ( _sendData ) sendData = _sendData;
    this.global.postRequestToken( 'request/rebates', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).rebates ) _rebates = response.json( ).rebates;
      if ( this.global.isFunction( cb ) ) cb( _rebates );
    });        
  }

  getRebateDataByID ( id, cb ) {
    let _rebate: Rebate = new Rebate( );
    let sendData = { id: id };
    this.global.postRequestToken( 'request/rebate', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).rebate ) _rebate = response.json( ).rebate;
      if ( this.global.isFunction( cb ) ) cb( _rebate );
    });        
  }

  addRebate ( RebateData, cb ) {

    let sendData = { rebate: RebateData };
    this.global.postRequestToken( 'request/addRebate', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  editRebate ( RebateData, cb ) {

    let sendData = { rebate: RebateData };
      this.global.postRequestToken( 'request/editRebate', sendData, this.loginService.userInfo.token, ( response ) => {
        if ( !this.checkToken( response ) ) return;
        if ( this.global.isFunction( cb ) ) cb( response );
      });
  }


  /*==============================================================================*\
  
                                SUPPLIER API

  \*==============================================================================*/  

  getSuppliersData ( cb, _sendData? ) {

    let _suppliers = [];
    let sendData = { };
    if ( _sendData ) sendData = _sendData;
    this.global.postRequestToken( 'request/suppliers', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).suppliers ) _suppliers = response.json( ).suppliers;
      if ( this.global.isFunction( cb ) ) cb( _suppliers );
    });        
  }

  getSupplierDataByID ( id, cb ) {
    let _supplier: Supplier = new Supplier( );
    let sendData = { id: id };
    this.global.postRequestToken( 'request/supplier', JSON.stringify( sendData ), this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).supplier ) _supplier = response.json( ).supplier;
      if ( this.global.isFunction( cb ) ) cb( _supplier );
    });        
  }

  addSupplier ( SupplierData, cb ) {

    let sendData = { supplier: SupplierData };
    this.global.postRequestToken( 'request/addSupplier', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  editSupplier ( SupplierData, cb ) {

    let sendData = { supplier: SupplierData };
      this.global.postRequestToken( 'request/editSupplier', sendData, this.loginService.userInfo.token, ( response ) => {
        if ( !this.checkToken( response ) ) return;
        if ( this.global.isFunction( cb ) ) cb( response );
      });
  }



  /*==============================================================================*\
  
                                ZONES AND LIGHTS API

  \*==============================================================================*/  

  getZonesData ( projectID, cb ) {

    let _answer: any = '';

    let sendData = { projectID: projectID };
    let _json;
    this.global.postRequestToken( 'request/projectZones', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      _json = response.json( );
      if ( _json.answer ) _answer = _json.answer;
      if ( this.global.isFunction( cb ) ) cb( _answer, _json );
    });        

  }

  addCustomLightsGroup ( LightsData, cb ) {

    let sendData = { lightID: LightsData };
    this.global.postRequestToken( 'request/createCustomGroup', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }
  addLight ( LightData, cb ) {

    let sendData = { light: LightData };
    this.global.postRequestToken( 'request/addLight', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }

  getLightByID ( id, cb ) {

    let _light: Light = new Light( );
    let sendData = { id: id };

    this.global.postRequestToken( 'request/light', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).light ) _light = response.json( ).light;
      if ( this.global.isFunction( cb ) ) cb( _light );
    });

  }

  editLight ( LightData, cb ) {

    let sendData = { light: LightData };
    this.global.postRequestToken( 'request/editLight', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }


  deleteLight ( id, cb ) {

    let sendData = { id: id };
    this.global.postRequestToken( 'request/deleteLight', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }

  addZone ( zoneData, selectedOption, cb ) {

    let sendData = {
      zone: zoneData,
      active_option: selectedOption
    };
    this.global.postRequestToken( 'request/addZone', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }


  deleteZone ( id, cb ) {

    let sendData = { id: id };
    this.global.postRequestToken( 'request/deleteZone', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }

  createOptions ( id, cb ) {

      let sendData = { id: id };
      this.global.postRequestToken( 'request/createOptions', sendData, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          if ( this.global.isFunction( cb ) ) cb( response );
      });
  }

  saveActiveOption ( id, option, cb ) {

    let sendData = { id: id, option: option };
    this.global.postRequestToken( 'request/saveActiveOption', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }
  
  saveShowInProposalInfo ( id, option, show, cb ) {

      let sendData = { id: id, option: option, show: show };
      this.global.postRequestToken( 'request/saveShowInProposal', sendData, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          if ( this.global.isFunction( cb ) ) cb( response );
      });
  }

  saveApplyRebate ( id, apply_rebates, cb ) {

    let sendData = { id: id, apply_rebates: apply_rebates };
    this.global.postRequestToken( 'request/saveApplyRebate', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  saveCloneLineItems ( id, clone_line_items, cb ) {

    let sendData = { id: id, clone_line_items: clone_line_items };
    this.global.postRequestToken( 'request/saveCloneLineItems', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });
  }

  deleteProject ( id, cb ) {

    let sendData = { id: id };
    this.global.postRequestToken( 'request/deleteProject', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }


  deleteLights ( ids, cb ) {

    let sendData = { ids: ids };
    this.global.postRequestToken( 'request/deleteLights', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }


  getZoneByID ( id, cb ) {

    let _zone: Zone = new Zone( );
    let sendData = {
      id: id
    };

    this.global.postRequestToken( 'request/zone', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).zone ) _zone = response.json( ).zone;
      if ( this.global.isFunction( cb ) ) cb( _zone );
    });

  }

  editZone ( zoneData, cb ) {

    let sendData = {
      zone: zoneData
    };
    this.global.postRequestToken( 'request/editZone', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response );
    });

  }

  cloneZone ( zoneId, zoneName, cb ) {

    let _zone: string = '';
    let _answer: string = '';
    let sendData = { 
      id: zoneId,
      name: zoneName
    };
    this.global.postRequestToken( 'request/duplicateZone', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).zone ) _zone = response.json( ).zone;
      if ( response.json( ).answer ) _answer = response.json( ).answer;
      if ( this.global.isFunction( cb ) ) cb( _zone, _answer );
    });

  }

  cloneProject ( projectID, projectName, cb ) {

    let _zone: string = '';
    let _answer: string = '';
    let _id: number = 0;
    let sendData = { 
      id: projectID,
      name: projectName
    };
    this.global.postRequestToken( 'request/duplicateProject', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).answer ) _answer = response.json( ).answer;
      if ( response.json( ).id ) _id = response.json( ).id;
      if ( this.global.isFunction( cb ) ) cb( _answer, _id );
    });

  }

  moveLightToAnotherZone ( zoneID, light, LPL, cb ) {
    
    let _answer: string = '';

    let sendData = { 
      zoneID: zoneID,
      light: light,
      LPL: LPL
    };

    this.global.postRequestToken( 'request/moveLight', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).answer ) _answer = response.json( ).answer;
      if ( this.global.isFunction( cb ) ) cb( _answer );
    });
  }

  splitLightToAnotherZone ( zoneID, quantity, existingQuantity, light, cb, linkedQuantity ) {
    
    let _answer: string = '';

    let sendData = { 
      zoneID: zoneID,
      light: light,
      quantity: quantity,
      linkedQuantity: linkedQuantity
    };

    if ( existingQuantity !== undefined ) sendData['existingQuantity'] = existingQuantity;

    this.global.postRequestToken( 'request/splitLight', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).answer ) _answer = response.json( ).answer;
      if ( this.global.isFunction( cb ) ) cb( _answer );
    });
  }


  /*==============================================================================*\
  
                                PDF API

  \*==============================================================================*/  

  getProposalPDF ( data, html_parts, projectID, projectInfo, cb ) {

    let _for_html = '';
    let _url = '';
    let _data;
    let html_proposal_A = html_parts[0];
    let html_proposal_B = html_parts[1];
    let html_proposal_C = html_parts[2];
    let job_details = html_parts[3];
    let terms_start_break = true;
    if( !job_details || job_details.indexOf('undefined') !== -1 ) {
      job_details = '';
      terms_start_break = false;
    }

    _for_html += '<br /><br />';
    if ( projectInfo.CustomerName ) _for_html += projectInfo.CustomerName+'<br />';
    if ( projectInfo.Name && projectInfo.Company != projectInfo.Name ) _for_html += projectInfo.Name+'<br />';
    if ( projectInfo.Street ) _for_html += projectInfo.Street+'<br />';
    if ( projectInfo.City ) _for_html += projectInfo.City+', ';
    if ( projectInfo.State ) _for_html += projectInfo.State+' ';
    if ( projectInfo.ZipCode ) _for_html += projectInfo.ZipCode;

    let html = '';

    let _products_info = [];
    let _attachment:string = '';
    let options_array = ['A','B','C'];
    let _existingLightID = {
      'A': [],
      'B': [],
      'C': []
    };

    options_array.forEach(function(option) {
      for ( let i = 0; i < data[option].product_list.proposed.length; ++i ) {
        if ((_existingLightID[option].indexOf(data[option].product_list.proposed[i].id) === -1) && (projectInfo.show_in_proposal.indexOf(option) > -1)) {
          _existingLightID[option].push(data[option].product_list.proposed[i].id);
          let _bitCode = ( data[option].product_list.proposed[i].bitCode && data[option].product_list.proposed[i].bitCode != null && data[option].product_list.proposed[i].bitCode != 'null' ) ? data[option].product_list.proposed[i].bitCode : '';
          _attachment = '';
          if ( data[option].product_list.proposed[i].attachment ) _attachment = '<img class="product-info__image" src="'+data[option].product_list.proposed[i].attachment+'">';
          _products_info[option] += '<div class="page_break"></div>';
          _products_info[option] += '<div class="mb15"></div>';
          _products_info[option] += '  <div class="product-info__container">';
          _products_info[option] += '    <div class="product-info">';
          _products_info[option] += '   <div class="bid-code">'+_bitCode+'</div>'
          if ( _attachment ) _products_info[option] += '<div class="product-info__image-wrapper">'+_attachment+'</div>';
          _products_info[option] += '      <div>';
          _products_info[option] += '        <div class="product-info__title">'+data[option].product_list.proposed[i].description+'</div>';
          _products_info[option] += '      <div class="product-info__basic-specs">'+data[option].product_list.proposed[i].basicSpec+'</div>';
          if ( data[option].product_list.proposed[i].specsPDF ) _products_info[option] += '      <div class="product-info__basic-specs"><a href="'+data[option].product_list.proposed[i].specsPDF+'">Click here to see Specifications</a></div>';
          _products_info[option] += '      </div>';
          _products_info[option] += '    </div>';
          _products_info[option] += '  </div>';
          _products_info[option] += '</div>';
        }
      }

      if( (data[option].product_list.proposed.length > 0) && (projectInfo.show_in_proposal.indexOf(option) > -1) ) {
        _products_info[option] += '<div class="page_break"></div>';
      }

    });

    html = html.replace( 'Maintenance savings during LED lifetime', 'Maintenance Savings' );

    if( data["A"].product_list.proposed.length > 0 ) {
      html += html_proposal_A + _products_info["A"];
      html = html.replace('undefined', '');
    }
    if( data["B"].product_list.proposed.length > 0 ) {
      html += html_proposal_B + _products_info["B"];
      html = html.replace('undefined', '');
    }
    if( data["C"].product_list.proposed.length > 0 ) {
      html += html_proposal_C + _products_info["C"];
      html = html.replace('undefined', '');
    }
    html += job_details;
    html += this.PDFHandler.getProposalTerms( terms_start_break );
    
    this.PDFHandler.generateProposalPDF( _for_html, projectInfo.proposal_id, projectInfo.newInstallation, projectInfo );

    let sendData = {
      html: this.PDFHandler.styles+this.PDFHandler.content+'<div class="container">'+html+'</div>',
      projectName: projectInfo.Name+'_proposal',
      projectID: projectID,
      type: 'proposal'
    };
    this.global.postRequestToken( 'request/PDF', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).url ) _url = response.json( ).url;
      if ( response.json( ).data ) _data = response.json( ).data;
      if ( this.global.isFunction( cb ) ) cb( _url, _data );
    });

  }

  getInvoicePDF ( data, projectID, projectInfo, cb ) {

    let _url = '';
    let _data;

    this.PDFHandler.generateInvoicePDF( data, projectInfo );
    
    let sendData = {
      html: this.PDFHandler.styles+this.PDFHandler.content,
      projectName: projectInfo.Name+'_invoice',
      projectID: projectID,
      type: 'invoice'
    };
    this.global.postRequestToken( 'request/PDF', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).url ) _url = response.json( ).url;
      if ( response.json( ).data ) _data = response.json( ).data;
      if ( this.global.isFunction( cb ) ) cb( _url, _data );
    });

  }


  sendProductsCSV ( file, cb ) {
    
    let sendData = { file: file };
    this.global.postRequestToken( 'request/importCSV', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });

  }

  sendSpecs ( file, cb ) {

    let sendData = { file: file };
    this.global.postRequestToken( 'request/importSpecs', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });

  }


  saveProjectOrder ( projectID, data, cb ) {

    let sendData = {
      projectID: projectID,
      data: data
    };
    this.global.postRequestToken( 'request/order', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  
  }


  uploadProductSpecs ( pdf, name, cb ) {

    this.global.postRequestToken( 'request/uploadSpecs', pdf, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    }, false, false, true );

  }

  uploadMultipleSpecs( pdf, cb ) {

      this.global.postRequestToken( 'request/importSpecs', pdf, this.loginService.userInfo.token, ( response ) => {
          if ( !this.checkToken( response ) ) return;
          if ( this.global.isFunction( cb ) ) cb( response.json( ) );
      }, false, false, true );
  }

  // uploadElectricBill ( img, name, cb ) {
  uploadElectricBill ( _sendData, cb ) {

    // let sendData = {
    //   img: img,
    //   project_name: name
    // };
    this.global.postRequestToken( 'request/uploadElectricBill', _sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    }, false, false, true );

  }

  uploadFloorPlan ( pdf, name, cb ) {

    let sendData = {
      file: pdf,
      name: name
    };
    this.global.postRequestToken( 'request/uploadFloorPlan', pdf, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    }, false, false, true );

  }

  uploadProjectDocument ( pdf, name, cb ) {

    let sendData = {
      file: pdf,
      name: name
    };
    this.global.postRequestToken( 'request/uploadProjectDocument', pdf, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    }, false, false, true );

  }

  uploadRebatesPDF ( pdf, name, cb ) {

    let sendData = {
      file: pdf,
      name: name
    };
    this.global.postRequestToken( 'request/uploadRebatesPDF', pdf, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    }, false, false, true );

  }




  /*==============================================================================*\
  
                                NOTES API

  \*==============================================================================*/  



  addNote ( e_type, e_id, text, cb ) {

    let sendData = {
      entityID: e_id,
      entityType: e_type,
      text: text
    };
    this.global.postRequestToken( 'request/addNote', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  getNotes ( e_type, e_id, cb ) {

    let _notes;
    let sendData = {
      entityID: e_id,
      entityType: e_type
    };
    this.global.postRequestToken( 'request/notes', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( response.json( ).notes ) _notes = response.json( ).notes;
      if ( this.global.isFunction( cb ) ) cb( _notes );
    });
  
  }


  /*==============================================================================*\
  
                                COLORS API

  \*==============================================================================*/  


  changeProductTypeColor ( _sendData, cb? ) {

    this.global.postRequestToken( 'request/addColorMatch', _sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( cb && this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  editColor ( lightID, cb? ) {

    let sendData = { groupColor: lightID };
    this.global.postRequestToken( 'request/editColor', sendData, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( cb && this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  resetColorsBindings ( projectID, cb ) {
    this.global.postRequestToken( 'request/clearColorMatches', { projectID: projectID }, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

  removeCopiedFrom ( projectID, selectedOption, cb ) {
    this.global.postRequestToken( 'request/removeCopiedFrom', { projectID: projectID, active_option: selectedOption }, this.loginService.userInfo.token, ( response ) => {
      if ( !this.checkToken( response ) ) return;
      if ( this.global.isFunction( cb ) ) cb( response.json( ) );
    });
  }

}





// WEBPACK FOOTER //
// /root/anvel/angular/app/services/model.service.ts